import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "../actionCreators";

export type State = number[];

const initialState: State = [];

const idsOfFetchingFiltersReducer = reducer(
  initialState,
  on(AC.userFilterGetFilterByIdRequest, (state, { payload }) => [
    ...state,
    payload.filterId,
  ]),
  on(
    AC.userFilterGetFilterByIdSuccess,
    AC.userFilterGetFilterByIdError,
    (state, { payload }) => state.filter((id) => id !== payload.filterId)
  )
);

export default idsOfFetchingFiltersReducer;
export type IdsOfFetchingFilters = State;
